import { Skeleton } from '@mui/material'
import { type HeadItemType, NotFound, SectionCard, Table } from 'components'
import { useSelector } from 'store/store'

import * as S from './styles'

export const PartnersSection = () => {
  const {
    detailedInfo: { Parceiros },
    loadingDetailedInfo: loading,
  } = useSelector((state) => state.ov)

  const headValues: HeadItemType[] = [
    { columnName: 'TipoParceiro', label: 'Tipo Parceiro' },
    { columnName: 'CodigoParceiro', label: 'Código do Parceiro' },
    { columnName: 'NomeParceiro', label: 'Nome do Parceiro' },
  ]

  const renderSkeleton = () => {
    const skeleton = []
    for (let i = 0; i < 3; i++) {
      skeleton.push({
        content: [
          <Skeleton height={30} key="partner-skeleton-1" width={200} />,
          <Skeleton height={30} key="partner-skeleton-2" width={125} />,
          <Skeleton height={30} key="partner-skeleton-3" />,
        ],
        id: `partner-loading-${i}`,
      })
    }
    return skeleton
  }

  const renderBody = () => {
    const content = loading
      ? renderSkeleton()
      : Parceiros.map((partner, index) => {
          return {
            content: [partner.Tipo, partner.Codigo, partner.Nome],
            id: `partner-${index}`,
          }
        })

    return content
  }

  return (
    <SectionCard
      title="Parceiros"
      tooltipText="Nesta seção você pode ver as partes envolvidas na execução desta OV, contemplando fornecedores até próprio Executivo de Vendas."
    >
      <S.Wrapper>
        <>
          {!loading && !Parceiros.length ? (
            <NotFound
              description="Os parceiros relacionados à Ordem de Venda serão listados aqui."
              title="Nenhum parceiro encontrado"
            />
          ) : (
            <Table
              bodyData={renderBody()}
              distributeWidth={false}
              headData={headValues}
              rowHeight={32}
            />
          )}
        </>
      </S.Wrapper>
    </SectionCard>
  )
}
